import React from "react";
import Avatar from "@mui/material/Avatar";
import { useEffect } from "react";
import { useState } from "react";

export function MuiAvatar({ src, fullName, children, ...props }) {
    const splittedName = fullName ? fullName.split(" ") : [];
    const [initialLetters, setInitialLetters] = useState("");

    const getFirstLetters = () => {
        let firstLetters = ""
        splittedName.map((name, index) => {
            // Breaking map on 2 index because we need maximum 2 letters to display in avatar if src is undefined
            if (index >= 2)
                return

            if (name)
                firstLetters += name[0].toUpperCase();
        });
        setInitialLetters(firstLetters)
    }

    useEffect(() => {
        if (fullName)
            getFirstLetters();
    }, [fullName]);

    return <Avatar src={src} {...props}>{children || initialLetters}</Avatar>
}